import { styled } from '@mui/system';
import { FontLite } from '../../theme';

export const epicStyles = {
    color: FontLite,
    fontSize: '18px',
};

export const EpicContainer = styled('div')(({ theme }) => ({
    alignItems: 'flex-end',
    color: '#f8f6f0',
    marginRight: '30px',
    '&>button': {
        color: '#f8f6f0',
        textTransform: 'none',
        fontSize: '14px',
    },
    [theme.breakpoints.down('md')]: {
        display: 'none',
    },
}));
